<ng-container *transloco="let t; read: 'service-exceptions'">
  <p-messages severity="info">
    <ng-template pTemplate>
      <div class="ml-2">{{ t('description') }}</div>
    </ng-template>
  </p-messages>
</ng-container>
<app-service-exceptions-table></app-service-exceptions-table>
